import PersonalInterview from 'interview/services/personal-interview'
import { httpError } from 'actions/http'
import { setLanguage } from 'actions'

export const PERSONAL_INTERVIEW_RECEIVE = 'PERSONAL_INTERVIEW_RECEIVE'
export const PERSONAL_INTERVIEW_CREATE_CALENDAR_EVENT = 'PERSONAL_INTERVIEW_CREATE_CALENDAR_EVENT'
export const PERSONAL_INTERVIEW_CALENDAR_EVENT_CREATED = 'PERSONAL_INTERVIEW_CALENDAR_EVENT_CREATED'

export const receivePersonalInterview = payload => ({ type: PERSONAL_INTERVIEW_RECEIVE, payload })

export const createCalendarEventRequest = () => ({ type: PERSONAL_INTERVIEW_CREATE_CALENDAR_EVENT })

export const calendarEventCreated = payload => ({ type: PERSONAL_INTERVIEW_CALENDAR_EVENT_CREATED, payload })

export const fetchPersonalInterview = params => dispatch => PersonalInterview.get(params.id)
  .then((personalInterview) => {
    dispatch(receivePersonalInterview(personalInterview))
    dispatch(setLanguage('en'))
  })
  .catch((err) => {
    if (err.response && err.response.status && err.response.status === 404) {
      dispatch(httpError(err.response.status))
    } else {
      throw err
    }
  })

export const createCalendarEvent = (slot, id) => (dispatch) => {
  dispatch(createCalendarEventRequest())
  PersonalInterview.createEvent(slot, id)
    .then((personalInterview) => {
      dispatch(receivePersonalInterview(personalInterview))
    })
    .catch((err) => {
      if (err.response && err.response.status && err.response.status === 404) {
        dispatch(httpError(err.response.status))
      } else {
        throw err
      }
    })
}
